<template>
  <div class="wrapper">
    <div class="sidebar">
      <img :src="sideImg" />
    </div>
    <div class="main">
      <div class="main-img-t">
        <img :src="wdwpTopImg" />
      </div>
      <div class="main-img-b">
        <img :src="wdwpBottomImg" />
      </div>
      <div class="content">
        <component :is="comKeyComponent" @handleClick="handleClick"></component>
      </div>
    </div>
  </div>
</template>

<script>
import sideImg from '../../assets/house/login_illustration.svg'
import wdwpBottomImg from '../../assets/house/WODEWUPINGCopy6@2x.png'
import wdwpTopImg from '../../assets/house/WODEWUPINGCopy7@2x.png'
import QrcodeComponent from './Qrcode'
import PasswordComponent from './Password'
import { isNull } from '../../common/utils'
const AV = require('leancloud-storage')
export default {
  name: 'ManagementLogin',
  data() {
    return {
      sideImg,
      wdwpBottomImg,
      wdwpTopImg,
      comKey: 'PasswordComponent',
    }
  },
  beforeCreate() {
    const { code } = this.$router.history.current.query
    if (!isNull(code)) {
      this.$message.loading('登录中...', 0)
      AV.Cloud.run('fetchAuthData', {
        code: code,
        type: 'web'
      }).then((res) => {
         this.login(res)
      }).catch((err) => {
          const msg = err.message.replace(/\[.*?\]/g, '')
          this.$message.destroy()
          this.$message.error(msg)
      })
    }
  },
  methods: {
    login(token){
       AV.User.loginWithAuthDataAndUnionId(token, 'overdue', token.unionid, { unionIdPlatform: 'weixin', asMainAccount: true}).then(
        () => {
          this.$message.destroy()
          this.$router.push({ path: `/house` })
        },
        (err) => {
          const msg = err.message.replace(/\[.*?\]/g, '')
          this.$message.destroy()
          this.$message.error(msg)
        }
      )
    },
    handleClick(e) {
      this.comKey = e
    },
  },
  computed: {
    comKeyComponent: function () {
      return this.comKey
    },
  },
  components: {
    QrcodeComponent,
    PasswordComponent,
  },
}
</script>
<style scoped lang="less">
.wrapper {
  display: flex;
  /* min-width: 1200px; */
  height: 100vh;
}
.sidebar {
  flex-basis: 440px;
}
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main {
  flex-grow: 1;
  display: flex;
  padding: 16px;
  position: relative;
  &-img-t {
    position: absolute;
  }
  &-img-b {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.content {
  width: 400px;
  height: 448px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.07);
  border-radius: 2px;
  margin: auto;
  padding: 50px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
}
</style>